var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptystateUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ilustracao-emptytate-up",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17329",
    "data-name": "Ret\\xE2ngulo 17329",
    width: 96,
    height: 96,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11654",
    "data-name": "Grupo 11654",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7279",
    "data-name": "Caminho 7279",
    d: "M44.144,11.922A38.468,38.468,0,1,1,5.676,50.389,38.468,38.468,0,0,1,44.144,11.922",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7280",
    "data-name": "Caminho 7280",
    d: "M64.868,27.286l-.225-.84a4.763,4.763,0,0,0-5.687-3.592l-10.7,2.865c1.442-4.445,2.578-10.146,1.256-14.752a6.045,6.045,0,0,0-2-3.287c-1.821-1.329-4.359-.57-5.878,1.012s-2.3,3.793-3.207,5.858A40.128,40.128,0,0,1,24.641,31.574l7.872,31.762,18.1-4.852,1.5-.4,4.5-1.206,10.695-2.865a4.765,4.765,0,0,0,3.13-5.955l-.225-.84a4.763,4.763,0,0,0-5.687-3.592,4.764,4.764,0,0,0,3.129-5.96l-.225-.839a4.764,4.764,0,0,0-5.687-3.593,4.764,4.764,0,0,0,3.124-5.948",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7281",
    "data-name": "Caminho 7281",
    d: "M32.514,64a.667.667,0,0,1-.648-.507L23.994,31.733a.665.665,0,0,1,.272-.712A39.61,39.61,0,0,0,37.825,14.284l.417-.971a16.332,16.332,0,0,1,2.924-5.082c1.644-1.718,4.57-2.685,6.753-1.092a6.579,6.579,0,0,1,2.249,3.644c1.29,4.488.31,9.887-.9,13.978l9.525-2.553A5.44,5.44,0,0,1,65.3,26.272l.225.841a5.788,5.788,0,0,1-.441,4.2,5.332,5.332,0,0,1-.938,1.283,5.689,5.689,0,0,1,3.936,4.059l.225.84a5.685,5.685,0,0,1-1.382,5.482,5.275,5.275,0,0,1,1.455.642,5.785,5.785,0,0,1,2.484,3.421l.225.841a5.788,5.788,0,0,1-.441,4.2,5.028,5.028,0,0,1-3.16,2.569l-34.8,9.322a.682.682,0,0,1-.179.023M25.4,31.86l7.6,30.654,34.138-9.147a3.7,3.7,0,0,0,2.324-1.9,4.444,4.444,0,0,0,.332-3.236l-.225-.842a4.458,4.458,0,0,0-1.912-2.636,3.7,3.7,0,0,0-2.961-.482.666.666,0,0,1-.818-.466l0-.006a.728.728,0,0,1-.022-.174.674.674,0,0,1,.5-.645A4.1,4.1,0,0,0,67,37.844L66.775,37a4.1,4.1,0,0,0-4.869-3.12.669.669,0,0,1-.818-.472.726.726,0,0,1-.022-.173.677.677,0,0,1,.5-.646,3.708,3.708,0,0,0,2.323-1.9,4.459,4.459,0,0,0,.331-3.24l-.225-.839a4.1,4.1,0,0,0-4.87-3.12L48.428,26.365a.668.668,0,0,1-.809-.852c1.3-4.008,2.571-9.756,1.248-14.362a5.314,5.314,0,0,0-1.753-2.932c-1.565-1.144-3.747-.373-5,.938a15.322,15.322,0,0,0-2.655,4.679l-.424.984A41.068,41.068,0,0,1,25.4,31.86",
    fill: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17325",
    "data-name": "Ret\\xE2ngulo 17325",
    width: 17.884,
    height: 1.336,
    transform: "translate(45.754 36.917) rotate(-15.001)",
    fill: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17326",
    "data-name": "Ret\\xE2ngulo 17326",
    width: 17.884,
    height: 1.336,
    transform: "translate(48.472 47.065) rotate(-15.001)",
    fill: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17327",
    "data-name": "Ret\\xE2ngulo 17327",
    width: 6.4,
    height: 1.336,
    transform: "translate(42.949 26.452) rotate(-14.996)",
    fill: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17328",
    "data-name": "Ret\\xE2ngulo 17328",
    width: 11.383,
    height: 32.894,
    transform: "translate(14.234 34.269) rotate(-15.009)",
    fill: "#97359e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7282",
    "data-name": "Caminho 7282",
    d: "M22.274,66.858,13.415,33.795,25.7,30.5l8.858,33.063ZM15.049,34.742l8.168,30.476,9.7-2.6L24.753,32.142Z",
    fill: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7283",
    "data-name": "Caminho 7283",
    d: "M82.612,77.433A11.424,11.424,0,1,1,71.188,66.009,11.424,11.424,0,0,1,82.612,77.433",
    fill: "#e5cce7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7284",
    "data-name": "Caminho 7284",
    d: "M71.187,72.989c2.471,0,3.238,1.9,3.238,4.426,0,2.555-.767,4.461-3.238,4.461s-3.238-1.906-3.238-4.461c0-2.531.767-4.426,3.238-4.426m0,1.56c-1.415,0-1.583,1.367-1.583,2.866,0,1.559.168,2.9,1.583,2.9s1.583-1.344,1.583-2.9c0-1.5-.168-2.866-1.583-2.866",
    fill: "#7e0386"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptystateUp);
export default __webpack_public_path__ + "static/media/emptystate-up.df2f943687c42861867aeae87fa6fe77.svg";
export { ForwardRef as ReactComponent };